import { mapGetters, mapActions } from "vuex";
import router from "../../router";
import moment from "../../plugins/moment";
import * as STEPPER_GETTER from "../../store/stepper/getter-types";
import * as STEPPER_ACTIONS from "../../store/stepper/action-types";
import * as BOOKING_GETTER from "../../store/booking/getter-types";
import * as DESTINIES_ACTIONS from "../../store/destinies/action-types";
import * as BOOKING_ACTIONS from "../../store/booking/action-types";
import updateBookingRouteParamMixin from "../../utils/mixins/updateBookingRouteParam";
import handleAppBarItems from "../../utils/handleAppBarItems";
import isValidFlight from "../../utils/isValidFlight";

export default {
  mixins: [updateBookingRouteParamMixin],
  data: function() {
    return {
      bookingLoaded: false,
      favoriteDestinies: [
        {
          image: "img/destinies/favorites/roma.jpg",
          title: "Roma",
          price: 30,
          link: ""
        },
        {
          image: "img/destinies/favorites/amsterdam.jpg",
          title: "Amsterdam",
          price: 50,
          link: ""
        },
        {
          image: "img/destinies/favorites/paris.jpg",
          title: "Paris",
          price: 50,
          link: ""
        },
        {
          image: "img/destinies/favorites/ibiza.jpg",
          title: "Ibiza",
          price: 30,
          link: ""
        },
        {
          image: "img/destinies/favorites/mallorca.jpg",
          title: "Mallorca",
          price: 30,
          link: ""
        },
        {
          image: "img/destinies/favorites/praga.jpg",
          title: "Praga",
          price: 50,
          link: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      stepper: STEPPER_GETTER.GET_STEPPER,
      activeStep: STEPPER_GETTER.GET_ACTIVE_STEP,
      booking: BOOKING_GETTER.GET_BOOKING,
      totalPrice: BOOKING_GETTER.GET_BOOKING_TOTAL_PRICE,
      travellersTotal: BOOKING_GETTER.GET_BOOKING_TRAVELLERS_TOTAL
    })
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.step !== "detalles") {
      next({ name: "checkout", params: { step: "detalles" }, query: to.query });
    } else {
      next();
    }
  },
  created() {
    this.resetStepper();

    this.$eventHub.$emit(
      "update-header",
      handleAppBarItems.call(this, router.currentRoute)
    );

    if (
      isValidFlight(this.booking.outgoingFlight) &&
      isValidFlight(this.booking.returnFlight) &&
      this.travellersTotal != null &&
      this.totalPrice != null
    ) {
      this.bookingLoaded = true;
    } else {
      this.retriveTripData();
    }

    // Show toast if coming from redsys error
    router.currentRoute.query.error &&
      this.$toastr.e(
        window.i18n.t('toast.error_2')
      );
  },
  methods: {
    ...mapActions({
      resetStepper: STEPPER_ACTIONS.RESET_STEPPER,
      checkTrip: DESTINIES_ACTIONS.CHECK_TRIP,
      setBooking: BOOKING_ACTIONS.SET_BOOKING
    }),
    retriveTripData() {
      const params = {
        origin: router.currentRoute.query.origen,
        destiny: router.currentRoute.query.destino,
        date: moment(router.currentRoute.query.fecha, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        ),
        adults: router.currentRoute.query.adults,
        children: router.currentRoute.query.childs,
        babies: router.currentRoute.query.babies,
        departureToken: router.currentRoute.query.departureToken
      };
      this.checkTrip(params)
        .then(trips => {
          const trip = trips[0];
          if (trip) {
            this.handleSetBooking(trip);
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          this.$toastr.e(
            window.i18n.t('toast.error_not_found_flights')
          );
          router.push(
            { name: "calendar",
              params: {
                origin: router.currentRoute.query.origen,
                destiny: router.currentRoute.query.destino },
                query: { adults: router.currentRoute.query.adults, childs: router.currentRoute.query.childs, babies: router.currentRoute.query.babies} });
        });
    },
    handleSetBooking(trip) {
      const booking = {
        bookingToken: trip.bookingToken,
        travellerPrice: parseFloat(trip.price),
        travellers: {
          adults: {
            total: parseInt(router.currentRoute.query.adults),
            data: {}
          },
          childs: {
            total: parseInt(router.currentRoute.query.childs),
            data: {}
          },
          babies: {
            total: parseInt(router.currentRoute.query.babies),
            data: {}
          }
        },
        outgoingFlight: {
          departure: {
            code: trip.airportFrom,
            airport: trip.routes[0].departure_airport.id,
            name: trip.cityFrom,
            datetime: moment(trip.journeyFlightDepartureTime)
          },
          arrival: {
            code: router.currentRoute.query.destino,
            airport: trip.routes[0].arrival_airport.id,
            name: trip.cityTo,
            datetime: moment(trip.journeyFlightArrivalTime)
          }
        },
        returnFlight: {
          departure: {
            code: router.currentRoute.query.destino,
            airport: trip.routes[1].departure_airport.id,
            name: trip.cityTo,
            datetime: moment(trip.returnFlightDepartureTime)
          },
          arrival: {
            code: trip.airportFrom,
            airport: trip.routes[1].arrival_airport.id,
            name: trip.cityFrom,
            datetime: moment(trip.returnFlightArrivalTime)
          }
        },
        airlines: router.currentRoute.query.airlines
      };

      this.setBooking(booking)
        .then(() => {
          this.bookingLoaded = true;
        })
        .catch(error => {
          this.$toastr.e(
            window.i18n.t('toast.error_3')
          );
          router.push({ name: "home-when" });
        });
    },
    goToStep: function(stepNumber) {
      if (stepNumber != this.stepper.activeStep) {
        this.$store.dispatch(STEPPER_ACTIONS.GO_TO_STEP, stepNumber);
      }
    }
  }
};
